 document.addEventListener("DOMContentLoaded", function() {

// PDP Social Share Button Popup START
    const toggleBtn = document.querySelector(".share-toggle");
    const icons = document.querySelector(".share-icons");

    toggleBtn.addEventListener("click", function() {
      if (icons.style.display === "none" || icons.style.display === "") {
        icons.style.display = "flex";
        icons.style.gap = "10px";
      } else {
        icons.style.display = "none";
      }
    });


    document.addEventListener("click", function(e) {
      if (!e.target.closest(".product-share-wrapper")) {
        icons.style.display = "none";
      }
    });

  });
  // PDP Social Share Button Popup END


 // Show button after scrolling down START
  window.addEventListener('scroll', function() {
    const scrollBtn = document.getElementById('scrollTopBtn');
    if (window.scrollY > 300) {
      scrollBtn.style.display = "flex";
    } else {
      scrollBtn.style.display = "none";
    }
  });

  // Scroll to top smoothly
  document.getElementById('scrollTopBtn').addEventListener('click', function() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }); 

  // Show button after scrolling down END

  // PDP Save Discount Badge START

    function updateBadge() {
        var badgeHtml = $('#dynamic-sale-badge-price').html();
        $('#dynamic-sale-badge').html(badgeHtml);

        // Hide if empty, show if not
        if ($('#dynamic-sale-badge').text().trim() === '') {
               $('#dynamic-sale-badge').css('visibility', 'hidden');
        } else {
             $('#dynamic-sale-badge').css('visibility', 'visible');
        }
    }

    // Observe the entire body for dynamic addition of #dynamic-sale-badge-price
    var bodyObserver = new MutationObserver(function(mutationsList) {
        mutationsList.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if ($(node).find('#dynamic-sale-badge-price').length || node.id === 'dynamic-sale-badge-price') {
                    // Element exists, start observing its content changes
                    updateBadge(); // Initial copy

                    var badgePriceNode = document.getElementById('dynamic-sale-badge-price');
                    var badgeObserver = new MutationObserver(updateBadge);
                    badgeObserver.observe(badgePriceNode, { childList: true, subtree: true });
                }
            });
        });
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });


// PDP Save BAdge END
